import React from "react";
import "./App.css";
import Login from "./component/login/login";
import Register from "./component/login/register/register";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Internet from "./component/internet/internet";
import Layout from "./component/layout/layout";
import Notfound from "./component/notfound/notfound";
import Homepage from "./component/homepage/homepage";
import Forgetpassword from "./component/forgetpassword/forgetpassword";
import ProtectedRouteHook from "./protect route/protectLogic";
import Profile from "./component/profile/profile";
import ProtectedRoute from "./protect route/ProtectedRouteHook";
import Service from "./component/service/service";
import Mainadminpage from "./component/dashboard/mainadmin/main";
import Employee from "./component/dashboard/employee/employee";
import Cars from "./component/dashboard/cars/cars";
import Detailsproduct from "./component/detailsproduct/detailsproduct";
import Productpage from "./component/productpage/productpage";
import Paymentmethod from "./component/user/carfeatuser/paymentProsses/paymentmethod/paymentmethod";
import Requetsuser from "./component/user/carfeatuser/paymentProsses/Requetsuser/Requetsuser";
import Requetsuserdetails from "./component/user/carfeatuser/paymentProsses/Requetsuserdetails/Requetsuserdetails";
import Banqi from "./component/user/carfeatuser/paymentProsses/banqi/banqi";
import Naqdi from "./component/user/carfeatuser/paymentProsses/naqdi/naqdi";
import Online from "./component/user/carfeatuser/paymentProsses/online/online";
import PaymenmethodAdmin from "./component/dashboard/paymentmethod/paymentmethod";
import Requetsadmin from "./component/dashboard/Requetsadmin/Requetsadmin";
import RequetsAdmindetailsss from "./component/dashboard/RequetsAdmindetails/RequetsAdmindetails";
import Akd from "./component/dashboard/akd/akd";
import Visaa from "./component/user/touristsfeatuser/Visaa/Visaa";
import Ticket from "./component/user/touristsfeatuser/Ticket/Ticket";
import Touritsmethod from "./component/user/touristsfeatuser/Touritsmethod/Touritsmethod";
import AllTouritsType from "./component/dashboard/TouristType/allTouristType";
import Recdence from "./component/user/touristsfeatuser/recdence/recdence";
import TrafficMethod from "./component/user/traffic/trafficmethod/trafficmethod";
import RetailMethod from "./component/user/traffic/retail/retail";
import ExtractL from "./component/user/traffic/retail/extractl";
import NewLec from "./component/user/traffic/retail/newlec";
import FaqedLec from "./component/user/traffic/retail/faqedlec";
import CarMethod from "./component/user/traffic/carss/carr";
import ExtractLCar from "./component/user/traffic/carss/extractl";
import NewLecCar from "./component/user/traffic/carss/newlec";
import FaqedLecCar from "./component/user/traffic/carss/faqedlec";
import Realstatemethod from "./component/user/realstate/realstatemethod/realstatemethod";
import Extractrequesr from "./component/user/realstate/extractrequesr";
import Tawkelwork from "./component/user/realstate/Tawkel";
import EditPrime from "./component/user/realstate/EditPrime";
import SliderAdmin from "./component/dashboard/sliderr/sliderr";
import Localmethod from "./component/user/localfeature/localfeature/localfeature";
import Build from "./component/user/localfeature/Build";
import Ardd from "./component/user/localfeature/ard";
import Adss from "./component/user/localfeature/Ads";
import Ashkhal from "./component/user/localfeature/ashkhal";
import Shoplec from "./component/user/localfeature/shoplec";
import Other from "./component/user/localfeature/Other";
import Masaed from "./component/user/localfeature/masaed";
import Takhlesmethod from "./component/user/tkhlesmoa/tkhlesmoa/tkhlesmoa";
import Gass from "./component/user/tkhlesmoa/Gas";
import Electric from "./component/user/tkhlesmoa/Electric";

function App() {
  const [isUser, isAdmin, isConsalt, userData] = ProtectedRouteHook();
  return (
    <div className="App">
      <BrowserRouter>
        <>
          {navigator.onLine === false ? (
            <Internet />
          ) : (
            <>
              <Layout userData={userData}>
                <Routes>
                  <Route path="/" element={<Homepage />} />
                  <Route path="/forgetpassword" element={<Forgetpassword />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route
                    path="/user/car/delatis/:id"
                    element={<Detailsproduct userData={userData} />}
                  />
                  <Route
                    path="/user/services/car"
                    element={<Productpage userData={userData} />}
                  />
                  <Route
                    path="/user/touristserv"
                    element={<Touritsmethod userData={userData} />}
                  />
                  <Route
                    path="/user/trafficserv"
                    element={<TrafficMethod userData={userData} />}
                  />
                  <Route
                    path="/user/realstatementserv"
                    element={<Realstatemethod userData={userData} />}
                  />
                  <Route
                    path="/user/localserv"
                    element={<Localmethod userData={userData} />}
                  />
   <Route
                    path="/user/takhlesserv"
                    element={<Takhlesmethod userData={userData} />}
                  />
                  <Route element={<ProtectedRoute auth={isUser} />}>
                    <Route path="/user/services" element={<Service />} />
                    <Route path="/user/banki" element={<Banqi />} />
                    <Route path="/user/naqdi" element={<Naqdi />} />
                    <Route path="/user/online" element={<Online />} />
                    <Route path="/user/tecketres" element={<Ticket />} />
                    <Route path="/user/visa" element={<Visaa />} />
                    <Route path="/user/recdence" element={<Recdence />} />
                    <Route
                      path="/user/retailmethod"
                      element={<RetailMethod />}
                    />
                    <Route path="/user/carmethod" element={<CarMethod />} />
                    <Route
                      path="/user/car/extractlec"
                      element={<ExtractLCar />}
                    />
                    <Route path="/user/car/newlec" element={<NewLecCar />} />
                    <Route
                      path="/user/car/faqedlec"
                      element={<FaqedLecCar />}
                    />
                    <Route
                      path="/user/retail/extractlec"
                      element={<ExtractL />}
                    />
                    <Route path="/user/retail/newlec" element={<NewLec />} />
                    <Route
                      path="/user/retail/faqedlec"
                      element={<FaqedLec />}
                    />
                    <Route path="/user/power" element={<Tawkelwork />} />
                    <Route
                      path="/user/extractrequest"
                      element={<Extractrequesr />}
                    />
                    <Route path="/user/editprime" element={<EditPrime />} />
                    <Route
                      path="/user/paymentmethods"
                      element={<Paymentmethod />}
                    />
                    <Route
                      path="/user/requestsuser"
                      element={<Requetsuser userData={userData} />}
                    />
                    <Route
                      path="/user/requestsuserdetails/:id"
                      element={<Requetsuserdetails />}
                    />
                    <Route path="/user/profile" element={<Profile />} />
                    <Route
                      path="/user/car/delatis/:id"
                      element={<Detailsproduct userData={userData} />}
                    />
                    <Route
                      path="/user/services/car"
                      element={<Productpage userData={userData} />}
                    />
                    <Route
                      path="/user/build"
                      element={<Build userData={userData} />}
                    />
               
                    <Route
                      path="/user/ads"
                      element={<Adss userData={userData} />}
                    />{" "}
                         <Route
                      path="/user/ard"
                      element={<Ardd userData={userData} />}
                    />{" "}
                    <Route
                      path="/user/ash"
                      element={<Ashkhal userData={userData} />}
                    />{" "}
                    <Route
                      path="/user/shope"
                      element={<Shoplec userData={userData} />}
                    />{" "}
                    <Route
                      path="/user/other"
                      element={<Other userData={userData} />}
                    />{" "}
                    <Route
                      path="/user/mesad"
                      element={<Masaed userData={userData} />}
                    />
                        <Route
                      path="/user/gas"
                      element={<Gass userData={userData} />}
                    />
                     <Route
                      path="/user/electric"
                      element={<Electric userData={userData} />}
                    />
                  </Route>
                  <Route element={<ProtectedRoute auth={isConsalt} />}>
                    <Route path="/consultant" element={<Mainadminpage />} />
                    <Route
                      path="/consultant/requestsuserdetails/:id"
                      element={<RequetsAdmindetailsss userData={userData} />}
                    />
                    <Route
                      path="/consultant/requests"
                      element={<Requetsadmin userData={userData} />}
                    />
                    <Route path="/consultant/profile" element={<Profile />} />
                  </Route>
                  <Route element={<ProtectedRoute auth={isAdmin} />}>
                    <Route path="/admin/profile" element={<Profile />} />
                    <Route
                      path="/admin/requests"
                      element={<Requetsadmin userData={userData} />}
                    />

                    <Route
                      path="/admin/paymenmethod"
                      element={<PaymenmethodAdmin />}
                    />
                    <Route path="/admin/ads" element={<SliderAdmin />} />
                    <Route
                      path="/admin/touristtype"
                      element={<AllTouritsType />}
                    />
                    <Route path="/admin/akd" element={<Akd />} />
                    <Route
                      path="/admin/requestsuserdetails/:id"
                      element={<RequetsAdmindetailsss userData={userData} />}
                    />

                    <Route path="/admin" element={<Mainadminpage />} />

                    <Route path="/admin/employee" element={<Employee />} />

                    <Route
                      path="/admin/cars"
                      element={<Cars userData={userData} />}
                    />
                    <Route
                      path="/admin/car/delatis/:id"
                      element={<Detailsproduct userData={userData} />}
                    />

                    <Route
                      path="/admin/touristtype"
                      element={<AllTouritsType />}
                    />

                    <Route path="/admin/employee" element={<Employee />} />
                  </Route>
                  <Route path="404" element={<Notfound />} />
                  <Route path="*" element={<Navigate to="/404" replace />} />
                </Routes>
              </Layout>
            </>
          )}
        </>
      </BrowserRouter>
    </div>
  );
}

export default App;
